import React, { useState, useEffect, useCallback } from 'react';
import api from '../../../services/api';
import { Table } from 'rsuite';
import RModal from '../../../components/Rsuite/Modal';
import { CustomCheckPicker } from '../../../components/CustomCheckPicker';
import { NotificationManager } from 'react-notifications';
import { useCustomTheme } from '../../../hooks/useCustomTheme';
import { CustomButton } from '../../../components/CustomButton';

const InserirBairros = ({ modal, close, regiao, id_empresa }) => {
  const [bairros, setBairros] = useState([]);
  const [regioesBairros, setRegioesBairros] = useState([]);
  const [idsBairro, setIdsBairro] = useState(null);
  const { Column, HeaderCell, Cell } = Table;
  const { theme } = useCustomTheme();

  const addBairro = async () => {
    if (idsBairro.length > 0) {
      let bairrosSelecionados = [];
      for (let i = 0; i < idsBairro.length; i++) {
        if (!existeBairroNaRegiao(idsBairro[i])) {
          const objeto = {
            value: idsBairro[i],
            label: idsBairro[i],
          };
          bairrosSelecionados.push(objeto);
          await api
            .post('regiao-bairro/criar', {
              IdEmpresa: +id_empresa,
              IdRegiao: regiao.Id,
              IdsBairro: bairrosSelecionados,
            })
            .then((res) => {
              NotificationManager.success('Produto inserido na montagem');
              setRegioesBairros((state) => [...state, ...res.data]);
              setIdsBairro('');
            });
        } else {
          NotificationManager.warning(
            'Bairros já se encontram na região',
            'Aviso',
          );
        }
      }
    } else {
      NotificationManager.warning('Selecione o bairro', 'Aviso');
    }
  };

  const existeBairroNaRegiao = (bairro) => {
    for (let i = 0; i < regioesBairros.length; i++) {
      if (regioesBairros[i].IdBairro === bairro) {
        return true;
      }
    }
    return false;
  };

  const alterarStatus = async (status, id) => {
    await api
      .post('regiao-bairro/alterarStatus', {
        Status: status,
        Id: id,
      })
      .then((res) => {
        NotificationManager.info('Produto alterado');
        setRegioesBairros((state) =>
          state.map((e) => {
            if (e.Id !== res.data.Id) {
              return e;
            }
            e = res.data;
            return e;
          }),
        );
      });
  };

  const abrirBairros = useCallback(
    async (regiao) => {
      await api.get(`regiao-bairro/listar/${regiao.Id}`).then((res) => {
        if (res.data.length > 0) {
          setRegioesBairros(res.data);
        }
      });

      setBairros([]);
      await api.get(`bairro/listarGestor/${id_empresa}`).then((res) => {
        let bairroSelect = [];
        res.data.forEach((obj) => {
          const novoObj = { value: obj.Id, label: `${obj.Bairro}` };
          bairroSelect.push(novoObj);
        });
        setBairros(bairroSelect);
      });
    },
    [id_empresa],
  );

  useEffect(() => {
    abrirBairros(regiao);
  }, [abrirBairros, id_empresa, modal, regiao]);

  useEffect(() => {
    setIdsBairro('');
  }, []);

  return (
    <RModal
      open={modal}
      onClose={close}
      size="lg"
      title="Bairros da região"
      footer={<></>}
    >
      <view
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: theme.colors.background,
          padding: '20px 30px',
        }}
      >
        <div
          style={{
            display: 'flex',
            padding: '0px 6px',
            gap: 10,
            marginBottom: 20,
            minWidth: 400,
          }}
        >
          <CustomCheckPicker
            placeholder="Selecione os bairros da região"
            data={bairros}
            defaultValue={''}
            onChange={setIdsBairro}
            style={{ flex: 1 }}
          />
          <CustomButton onClick={addBairro} appearance="primary">
            Inserir
          </CustomButton>
        </div>
        <Table
          height={260}
          style={{
            alignItems: 'center',
            justifyContent: 'center',
            borderColor: theme.colors.backgroundSecondary,
            backgroundColor: theme.colors.backgroundSecondary,
          }}
          data={regioesBairros}
        >
          <Column
            style={{
              background: theme.colors.backgroundSecondary,
              color: theme.colors.textSecondary,
            }}
            align="center"
          >
            <HeaderCell>Código</HeaderCell>
            <Cell dataKey="Id" />
          </Column>

          <Column
            style={{
              background: theme.colors.backgroundSecondary,
              color: theme.colors.textSecondary,
            }}
          >
            <HeaderCell>IdBairro</HeaderCell>
            <Cell dataKey="IdBairro" />
          </Column>

          <Column
            style={{
              background: theme.colors.backgroundSecondary,
              color: theme.colors.textSecondary,
            }}
          >
            <HeaderCell>Descricao</HeaderCell>
            <Cell dataKey="Descricao" />
          </Column>

          <Column
            style={{
              background: theme.colors.backgroundSecondary,
              color: theme.colors.textSecondary,
            }}
          >
            <HeaderCell>Ativo</HeaderCell>
            <Cell dataKey="Ativo">
              {(rowData) => (
                <span style={{ padding: 0 }}>
                  {rowData?.Ativo ? (
                    <CustomButton
                      appearance="ghost"
                      style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '0 10px',
                      }}
                      onClick={() => alterarStatus(0, rowData.Id)}
                    >
                      {' '}
                      Sim{' '}
                    </CustomButton>
                  ) : (
                    <CustomButton
                      appearance="primary"
                      style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '0 10px',
                      }}
                      onClick={() => alterarStatus(1, rowData.Id)}
                    >
                      {' '}
                      Não{' '}
                    </CustomButton>
                  )}
                </span>
              )}
            </Cell>
          </Column>
        </Table>
      </view>
    </RModal>
  );
};

export default InserirBairros;
